module.exports = __webpack_public_path__ + "6041405645d8394ca4dd8bfb1b1cc36b.png";